'use client';

import { Box, Container, Image } from '@doist/marketist';
import { useTranslation } from 'app/i18n/client';
import { SectionHeader } from 'components/SectionHeader/SectionHeader';
import { useLocale } from 'next-intl';
import css from './one-column-section.module.css';
function OneColumnSection() {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'karma');
  return <Container width="sm" className={css.container} data-sentry-element="Container" data-sentry-component="OneColumnSection" data-sentry-source-file="one-column-section.tsx">
            <SectionHeader size="lg" level="2" title={t('levels.title')} subtitle={t('levels.description')} style={{
      '--section-mb': 'var(--space-48)'
    }} data-sentry-element="SectionHeader" data-sentry-source-file="one-column-section.tsx" />
            <Box className={css.imageWrapper} data-sentry-element="Box" data-sentry-source-file="one-column-section.tsx">
                <Image src={`/static/karma/levels.png`} width={547} height={369} alt="" data-sentry-element="Image" data-sentry-source-file="one-column-section.tsx" />
            </Box>
        </Container>;
}
export { OneColumnSection };